export enum YesOrNoEnum {
    // 是
    YES = 1,
    // 否
    NO = 0,
}

export enum SettingCodeEnum {
    WEBSITE_TITLE = 'websiteTitle',
    WEBSITE_DESCRIPTION = 'websiteDescription',
    SIDE_LOGO_URL = 'sideLogoUrl',
    FOOTER_CONTENT = 'footerContent',
    FULL_VERSION = 'fullVersion',
    FRONTEND_FULL_VERSION = 'frontendFullVersion',
    FRONTEND_LATEST_FULL_VERSION = 'frontendLatestFullVersion',
    AGREEMENT = 'agreement',
    PRIVACY = 'privacy',

    // Portal 当前主题
    PORTAL_CURRENT_THEME = 'portalCurrentTheme',
    FILE_UPLOAD_ALLOW_MIME_TYPE = 'fileUploadAllowMimeType',
    FILE_UPLOAD_ALLOW_MAX_SIZE = 'fileUploadAllowMaxSize',
    FILE_UPLOAD_ALLOW_MESSAGE = 'fileUploadAllowMessage',

    // 商城
    MALL_WEBSITE_TITLE = 'mallWebsiteTitle',
}

export enum UserTypeEnum {
    // 员工
    EMPLOYEE = 1,
    // 客户
    CUSTOMER = 2,
}

export enum DictionaryCategoryCodeEnum {
    // 视图类型
    VIEW_TYPE = 'viewType',
    // 是或否
    YES_OR_NO = 'yesOrNo',
    // 用户类型
    USER_TYPE = 'userType',
    // 员工状态
    EMPLOYEE_STATUS = 'employeeStatus',
    // 存储
    FILE_STORAGE = 'fileStorage',
    // 商品类型属性模板表单类型
    PRODUCT_TYPE_ATTRS_TEMPLATE_INPUT_TYPE = 'productTypeAttrsTemplateInputType',
    // 文件存储业务类型
    FILE_STORAGE_BUSINESS_TYPE = 'fileStorageBusinessType',
    // 文件业务业务类型
    FILE_BUSINESS_BUSINESS_TYPE = 'fileBusinessBusinessType',
    // 文件 MIME 类型
    FILE_MIME_TYPE = 'fileMimeType',
    // 文件 MIME 类型图片
    FILE_MIME_TYPE_IMAGE = 'fileMimeTypeImage',
    // 文件 MIME 类型文档
    FILE_MIME_TYPE_DOCUMENT = 'fileMimeTypeDocument',
    // 文件 MIME 类型其它
    FILE_MIME_TYPE_OTHERS = 'fileMimeTypeOthers',
    // 文件类型
    FILE_TYPE = 'fileType',
    // 商品状态
    PRODUCT_STATUS = 'productStatus',
    // Post 类型
    POST_TYPE = 'postType',
    // Post 状态
    POST_STATUS = 'postStatus',
    // 通用
    COMMON = 'common',
}

export enum DictionaryKeyEnum {
    // Portal PC 链接
    PORTAL_PC_WEBSITE_LINK = 'portalPcWebsiteLink',
}

export const DictionaryCategoryCodeEnumForFileMimeType = [
    DictionaryCategoryCodeEnum.FILE_MIME_TYPE_IMAGE,
    DictionaryCategoryCodeEnum.FILE_MIME_TYPE_DOCUMENT,
    DictionaryCategoryCodeEnum.FILE_MIME_TYPE_OTHERS,
]

export enum ViewTypeEnum {
    // 菜单
    MENU = 1,
    // 按钮
    BUTTON = 2,
}

export enum FileStorageBusinessTypeEnum {
    SYSTEM = 1,
    MALL = 2,
}
